<script>
import { drop } from 'lodash'

export default {
  name: 'BreadCrumbs',
  computed: {
    items() {
      let items = []
      const { name, fullPath } = this.$route
      let path = fullPath.split('/')
      switch (name) {
        case 'systemSettings':
        case 'dictionary':
        case 'account':
        case 'reports-view':
        case 'alerts-view':
        case 'remains':
        case 'events':
        case 'heartbeats':
        case 'invalidEvents':
        case 'workshops':
        case 'devices':
        case 'workshop':
        case 'warehouses':
        case 'warehouse':
          path = drop(path, 1)
          break
        default:
          path = drop(path, 2)
          break
      }
      items = path
      return items
    },
    isDictionary() {
      return (
        this.$route.name === 'systemSettings' ||
        this.$route.name === 'dictionary'
      )
    },
    isDocument() {
      return this.$route.name === 'document'
    },
    documentId() {
      return this.$route.params.documentId || null
    },
    documentType() {
      return this.$route.params.documentType || null
    },
  },
  methods: {
    modifyValue(value) {
      if (this.isDictionary) {
        return this.$t(`navigation_links__${value}`)
      }
      switch (this.$route.name) {
        case 'contact':
          const contact = this.$store.getters['data/getItemFromDictionary'](
            'contact',
            Number(value)
          )
          return contact ? `${contact.firstName} ${contact.lastName}` : value
        case 'user':
          const user = this.$store.getters['data/getItemFromDictionary'](
            'user',
            Number(value)
          )
          return user ? `${user.firstName} ${user.lastName}` : value
        case 'workshop':
        case 'warehouse':
        case 'organization':
          const organization = this.$store.getters[
            'data/getItemFromDictionary'
          ]('organization', Number(value))
          return organization ? organization.shortName : value
        case 'goodsItem':
          const good = this.$store.getters['data/getItemFromDictionary'](
            'goods',
            Number(value)
          )
          return good ? good.shortName : value
        case 'reports-view':
        case 'alerts-view':
          return this.$t(`reports__${value}`)
        case 'heartbeats': {
          if (value === 'connectedPlugs') {
            return this.$t(`navigation_links__connected_plugs`)
          }
          return value
        }
        default:
          return value
      }
    },
    getLink(value) {
      switch (value) {
        case 'all':
        case 'accept':
        case 'completeSet':
        case 'shipment':
        case 'returns':
        case 'writeOff':
        case 'change':
          return { name: 'documents', params: { documentType: value } }
        case 'users':
        case 'roles':
          return `/control/${value}`
        case 'goods':
        case 'organizations':
        case 'contacts':
          return `/dictionaries/${value}`
        case 'systemSettings':
          return '/systemSettings'
        case 'dictionaries':
          return '/dictionaries/list'
        case 'reports':
          return '/reports'
        case 'alerts':
          return '/alerts'
        case 'heartbeats':
          return '/heartbeats'
        case 'connectedPlugs':
          return ''
        case 'InvalidMeasurement':
          return '/alerts/InvalidMeasurement'
        case 'workshops':
          return '/workshops'
        case 'warehouses':
          return '/warehouses'
        case 'devices':
          return '/devices'
        default:
          return value
      }
    },
    whantCloseDocument() {
      this.$root.$emit('whant-close-document', null)
    },
  },
}
</script>

<template>
  <div>
    <v-breadcrumbs
      v-if="isDocument "
      divider="/"
      large>
      <v-breadcrumbs-item @click.native="whantCloseDocument()"> {{ $t(`navigation_links__${documentType}`) }}</v-breadcrumbs-item>
      <v-breadcrumbs-item>{{ documentId }}</v-breadcrumbs-item>
    </v-breadcrumbs>
    <v-breadcrumbs
      v-else
      divider="/"
      large>
      <v-breadcrumbs-item
        v-for="(item, index) in items"
        :key="item"
        :to="getLink(item)"
        exact>
        {{ index >= 1 ? modifyValue(item) : (item !== 'searchPlug'? $t(`navigation_links__${item}`):'') }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>
  </div>
</template>
